import { Injectable } from '@angular/core';
import { User } from '../_models/user';
import { Resolve, Router, ActivatedRouteSnapshot } from '@angular/router';
import { UserService } from '../_services/user.service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationService } from '../_services/notification.service';
import { AuthService } from '../_services/auth.service';

@Injectable()
export class UserEditResolver implements Resolve<User> {

    constructor(
        private userService: UserService, 
        private router: Router, 
        private authService: AuthService,
        private notify: NotificationService
    ) { }

    isUserValid(routeId: number, adminUser: User): boolean {
        const isRouteEqual = routeId !== adminUser.id,
              isRoleValid = adminUser.role !== 0;

        return isRouteEqual && isRoleValid;
    }

    resolve(route: ActivatedRouteSnapshot): Observable<User> {
        const routeId = Number(route.params['id']),
              user = this.authService.getAdminUser();

        if (this.isUserValid(routeId, user)) {
            this.router.navigate(['/users']);
            return of(null);
        }

        return this.userService.getUser(routeId).pipe(
            catchError(error => {
                this.notify.error(error);
                this.router.navigate(['/users']);
                return of(null);
            })
        );
    }
}
